import useRequest from 'Utils/Hooks/useRequest';
import {getRoleFunctionTree} from '../../service';
import AuthCard from '../AuthCard';
import useAuth from '../../../../../Utils/Hooks/useAuth';

interface AuthTreeProps {
    roleId: string;
}

export function AuthTree({roleId}: AuthTreeProps) {
    const auth = useAuth();

    const [data, , refresh] = useRequest(
        async () => getRoleFunctionTree(roleId),
        {},
        [roleId],
    );

    if (!data) return null;

    return (
        <div style={{pointerEvents: auth('SF_J476Zfxw39') ? 'auto' : 'none'}}>
            {data.map(item => (
                <AuthCard
                    key={item.code}
                    data={item}
                    roleId={roleId}
                    onChange={refresh}
                />
            ))}
        </div>
    );
}
